import EventsFallback from '../../../../lib/events_fallback';

namespace('IO.Views.Components.Rje', function (exports) {
  var INTERVAL = 15000,
    Codes = IO.Views.Components.Rje.Codes,
    // StatePoll feed various components, so in case of error we can't let those
    // so in this specific use case StatePoll itself trigger the Alert.
    // components report an Alert on UI or we will get various UI alerts for a single error.
    // Another solution would be to create yet another component to just listen to this general
    // errors...
    CodeToState = function (code) {
      switch (code) {
        case Codes.STATE_RUNNING:
          output = 'online';
          break;
        case Codes.STATE_UNKNOWN:
          output = 'unknown';
          break;
        default:
          output = 'offline';
          break;
      }
      return output;
    };

  exports.StatePoll = class StatePoll extends EventsFallback {
    constructor(...args) {
      super(...args);
      this.stopped = false;
    }

    start(url) {
      this.url = url;
      this._statusInterval();
    }

    stop() {
      this.stopped = true;
    }

    _statusInterval() {
      var req = this._makeGetRequest(this.url);

      req.done(_.bind(this._statusIntervalDoneCallback, this));
      req.fail(_.bind(this._statusIntervalFailCallback, this));
    }

    _statusIntervalDoneCallback(resp) {
      this.trigger('node:puppet', resp.puppet);
      this.trigger('node:status', CodeToState(resp.state));
      this.trigger('virtuals', resp.virtuals);

      if (!this.stopped) {
        setTimeout(_.bind(this._statusInterval, this), INTERVAL);
      }
    }

    _statusIntervalFailCallback(resp) {
      console.log('fail interval:', resp); // eslint-disable-line no-console
      this.trigger('error');

      this._alert({
        message:
          resp.responseText || 'An error occurred. Please contact support.',
        type: 'alert',
      });
      if (resp.status === 503) {
        this.stop();
      }
      if (!this.stopped) {
        setTimeout(_.bind(this._statusInterval, this), INTERVAL);
      }
    }

    _makeGetRequest(url) {
      return $.ajax({
        url: url,
      });
    }

    _alert(args) {
      if (this.alert) {
        this.alert.close();
      }
      this.alert = new Alert(args);
      this.alert.prependTo('#main-content').show();
    }
  };
});
